"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.talkToSalesTypeSelector = exports.purchaseMotionsSelector = void 0;

var _PurchaseMotionTypes = require("ui-addon-upgrades/_core/purchaseMotions/PurchaseMotionTypes");

var _HubMap = _interopRequireDefault(require("self-service-api/constants/HubMap"));

var _PurchaseMotionsLocations = require("pricing-pages-unified-ui/constants/PurchaseMotionsLocations");

var purchaseMotionsSelector = function purchaseMotionsSelector(state, location, merchId) {
  var mon307ExcludeTts = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var purchaseMotions = state.purchaseMotionsByLocation && state.purchaseMotionsByLocation[location] && state.purchaseMotionsByLocation[location].purchaseMotions[merchId];
  if (!purchaseMotions) purchaseMotions = [];
  return purchaseMotions.map(function (_ref) {
    var key = _ref.key;
    return key;
  }).filter(function (key) {
    return !(mon307ExcludeTts && [_PurchaseMotionTypes.TALK_TO_SALES_FALLBACK, _PurchaseMotionTypes.TALK_TO_SALES].includes(key));
  });
};

exports.purchaseMotionsSelector = purchaseMotionsSelector;

var talkToSalesTypeSelector = function talkToSalesTypeSelector(state, hub) {
  var highlightedMerch = _HubMap.default[hub].highlightedPaidMerch;
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = highlightedMerch[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var merchId = _step.value;
      var purchaseMotions = purchaseMotionsSelector(state, _PurchaseMotionsLocations.EXTENDED_MERCH_CARD, merchId);
      if (purchaseMotions.includes(_PurchaseMotionTypes.TALK_TO_SALES)) return _PurchaseMotionTypes.TALK_TO_SALES;
      if (purchaseMotions.includes(_PurchaseMotionTypes.TALK_TO_SALES_FALLBACK)) return _PurchaseMotionTypes.TALK_TO_SALES_FALLBACK;
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return null;
};

exports.talkToSalesTypeSelector = talkToSalesTypeSelector;


//////////////////
// WEBPACK FOOTER
// ./js/selectors/PurchaseMotionSelectors.js
// module id = 154
// module chunks = 5 6 7